"use strict";

exports.__esModule = true;
exports.History = void 0;
var _transfers = require("./fetchers/transfers");
var _swap = require("./fetchers/swap");
var _earn = require("./fetchers/earn");
var _loan = require("./fetchers/loan");
var _homa = require("./fetchers/homa");
class History {
  constructor(configs) {
    this.configs = void 0;
    this.transfer = void 0;
    this.swap = void 0;
    this.earn = void 0;
    this.loan = void 0;
    this.homa = void 0;
    this.configs = configs;

    // initizlize hisotry fetcher
    this.transfer = new _transfers.Transfers({
      endpoint: this.configs.fetchEndpoints.transfer,
      poolInterval: this.configs.poolInterval,
      wallet: this.configs.wallet
    });
    this.swap = new _swap.Swaps({
      endpoint: this.configs.fetchEndpoints.swap,
      poolInterval: this.configs.poolInterval,
      wallet: this.configs.wallet
    });
    this.earn = new _earn.Earns({
      endpoint: this.configs.fetchEndpoints.earn,
      stakingEndpoint: this.configs.fetchEndpoints.staking,
      poolInterval: this.configs.poolInterval,
      wallet: this.configs.wallet
    });
    this.loan = new _loan.Loans({
      endpoint: this.configs.fetchEndpoints.loan,
      poolInterval: this.configs.poolInterval,
      wallet: this.configs.wallet
    });
    this.homa = new _homa.Homas({
      endpoint: this.configs.fetchEndpoints.homa,
      poolInterval: this.configs.poolInterval,
      wallet: this.configs.wallet
    });
  }
}
exports.History = History;